module.exports = __webpack_public_path__ + "img/help-permission.99f7f288.svg";